import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/app/store/hooks";

import { useBlacklistTokenMutation } from "@/features/auth/api/authApi";
import { logout } from "@/features/auth/authSlice";
import { clearBrandingCss } from "@/features/branding/brandingCss";

import { BARE_LOGIN_PATH } from "@/shared/lib/tenantSlug";

/** End session: clear client state, redirect to login, blacklist refresh token when present. */
export function useLogout() {
  const dispatch = useAppDispatch();
  const refreshToken = useAppSelector((s) => s.auth.refreshToken);
  const [blacklistToken] = useBlacklistTokenMutation();

  return useCallback(() => {
    const currentRefresh = refreshToken;
    dispatch(logout());
    clearBrandingCss();
    window.location.assign(BARE_LOGIN_PATH);
    if (currentRefresh) {
      void blacklistToken({ refresh: currentRefresh });
    }
  }, [blacklistToken, dispatch, refreshToken]);
}
